/**
 * Represents the application logo
 */
export class DinapsisNavbarLogo {
    constructor(srcImage) {
        /**
         * Gets or sets the status of the side nav if is open or not
         */
        this.srcImage = '';
        this.srcImage = srcImage;
    }
    /**
     * Create the custom component
     * @returns HTML code of the component
     */
    Render() {
        const listelement = document.createElement('div');
        listelement.innerHTML = `<div class="container">
          <img src=${this.srcImage} alt="LOGO" onerror="this.style.display='none'"/>
      </div>`;
        return listelement;
    }
}
//# sourceMappingURL=dinapsis-navbar-logo.js.map